import {useCallback, useEffect, useState} from 'react';
import {connectSocket, getSocket, setSocketHandlers} from '../services/socket/socketClient';

export default function useAppSocket(handlers) {
  const [socket, setSocket] = useState(getSocket);

  useEffect(() => {
    setSocketHandlers(handlers);
  });

  const connect = useCallback(async () => {
    const next = await connectSocket();
    setSocket(next);
    return next;
  }, []);

  return {socket, connect};
}
